import axios from 'axios';

const getErrorData = (error: unknown): Record<string, unknown> | undefined => {
  if (!axios.isAxiosError(error) || error.response?.status !== 400) return undefined;
  const data = error.response.data;
  if (!data || typeof data !== 'object') return undefined;
  return data as Record<string, unknown>;
};

export const isUnsafeItemTitleError = (error: unknown): boolean => {
  const data = getErrorData(error);
  if (!data) return false;

  if (data.titleNotSafe || data.wrongTitle) return true;

  return Array.isArray(data.errorCodes) && data.errorCodes.includes('UNSAFE_TITLE');
};

export const getUnsafeImageUrls = (error: unknown): string[] => {
  const data = getErrorData(error);
  if (!data || !Array.isArray(data.unsafeImageUrls)) return [];
  return data.unsafeImageUrls.filter((url): url is string => typeof url === 'string');
};
